export default __webpack_public_path__ + "static/c79c0b5ccf741f6fea4f547edfa3ac99.webp";